import React from "react";
import { Box } from "@mui/material";

// Shared look of the admin's data tables (Payment Analytics, User Management).
export const cellSx = { px: 1.5, py: 1.25, fontSize: 13, color: "#3C4043", verticalAlign: "middle", borderBottom: "1px solid #F0F0F0" };
export const headSx = {
  px: 1.5, py: 1.25, fontSize: 12, fontWeight: 600, color: "#6A7282", textTransform: "uppercase", letterSpacing: "0.03em",
  whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 2, background: "#F8F8F8", borderBottom: "1px solid #E6E6E6"
};
// Keeps the member column in view while a wide table scrolls sideways.
export const stickySx = { position: "sticky", left: 0, zIndex: 1, backgroundColor: "#fff", boxShadow: "inset -1px 0 0 #F0F0F0" };
export const stickyHeadSx = { left: 0, zIndex: 3, boxShadow: "inset -1px -1px 0 #E6E6E6" };
export const outlineBtnSx = {
  fontSize: '14px', color: '#0A0A0A', textTransform: 'none', fontWeight: 400, display: 'flex', alignItems: 'center',
  gap: '5px', border: '1px solid rgb(0, 0, 0, 0.1)', borderRadius: '8px', px: '12px', py: 0, height: 36
};
export const paginationSx = {
  "& .MuiPaginationItem-root": { color: "#3C4043", border: "1px solid #E6E6E6" },
  "& .Mui-selected": { backgroundColor: "#BE1F1F !important", borderColor: "#BE1F1F", color: "#fff" },
  "& .MuiPaginationItem-root:hover": { backgroundColor: "#FDECEA" },
};

// Keyed by the server's `statusBucket` (the canonical member status); utils/memberStatus names it.
export const STATUS_STYLE_MAP = {
  approved: { bg: "#E6F4EA", color: "#008E40" },
  hidden: { bg: "#E8F0FE", color: "#1A73E8" },
  inactive: { bg: "#F1F3F4", color: "#5F6368" },
  ghost: { bg: "#F3E8FD", color: "#9334E6" },
  deactivated: { bg: "#FFF4E5", color: "#F29900" },
  suspended: { bg: "#FDECEA", color: "#D93025" },
  deleted: { bg: "#FDECEA", color: "#D93025" }
};
export const DEFAULT_STATUS_STYLE = { bg: "#F1F3F4", color: "#5F6368" };

export const Muted = () => <span style={{ color: "#B0B0B0" }}>—</span>;

export const Pill = ({ children, bg = "#F1F3F4", color = "#5F6368", sx }) => (
  <Box component="span" sx={{
    display: "inline-flex", alignItems: "center", gap: 0.5, px: 1.25, py: "3px", borderRadius: "12px",
    fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", bgcolor: bg, color, ...sx
  }}>
    {children}
  </Box>
);

export const CountPill = ({ value, tone }) => (
  value > 0 ? (
    <Box component="span" sx={{
      display: "inline-block", minWidth: 28, px: 1, py: "2px", borderRadius: "10px", fontSize: 13, fontWeight: 600,
      color: tone || "#3C4043", bgcolor: tone ? `${tone}14` : "#F1F3F4"
    }}>
      {value.toLocaleString()}
    </Box>
  ) : <span style={{ color: "#C4C4C4" }}>0</span>
);
